export default __webpack_public_path__ + "static/media/jobs.078251d6.svg";